import ReactDefaultPrice from './ReactDefaultPrice'
import ReactPSUPrice from './ReactPSUPrice'
import { PriceVariant } from './types'
import IsInEditorText from '../shared/IsInEditorText'

const ReactPrice = (props: any) => {
  const { variant = PriceVariant.DEFAULT, isInEditor } = props

  const renderPriceComponent = () => {
    if (variant == PriceVariant.PSU) {
      return <ReactPSUPrice {...props} />
    } else return <ReactDefaultPrice {...props} />
  }

  return (
    <>
      {IsInEditorText(isInEditor, 'React Price')}
      <div className={`react-price-container price-variant-${variant}`}>{renderPriceComponent()}</div>
    </>
  )
}

export default ReactPrice
